<!-- 商品审核列表 -->
<template>
    <div class="main-container">
        <div class="filter-container">
            <el-input class="filter-item" v-model="filters.brand_name" placeholder="品牌" style="width:170px" clearable></el-input>
            <el-date-picker class="filter-item" v-model="filters.examine_start_time" type="date" placeholder="审核开始日期" value-format="YYYY-MM-DD" style="width:170px" clearable></el-date-picker>
            <span class="filter-divider">-</span>
            <el-date-picker class="filter-item" v-model="filters.examine_end_time" type="date" placeholder="审核结束日期" value-format="YYYY-MM-DD" style="width:170px" clearable></el-date-picker>
            <el-date-picker class="filter-item" v-model="filters.preparation_start_time" type="date" placeholder="制单开始日期" value-format="YYYY-MM-DD" style="width:170px" clearable></el-date-picker>
            <span class="filter-divider">-</span>
            <el-date-picker class="filter-item" v-model="filters.preparation_end_time" type="date" placeholder="制单结束日期" value-format="YYYY-MM-DD" style="width:170px" clearable></el-date-picker>
            <el-input class="filter-item" v-model="filters.title" placeholder="请输入商品名称" style="width:170px" clearable></el-input>
            <el-select class="filter-item" v-model="filters.check_status" placeholder="审核状态" style="width:170px" clearable>
                <el-option label="全部" value=""></el-option>
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="审核通过" :value="2"></el-option>
                <el-option label="驳回" :value="3"></el-option>
            </el-select>
            <el-input class="filter-item" v-model="filters.second_brand_name" placeholder="请输入二级品牌" clearable style="width:170px"></el-input>
            <el-input class="filter-item" v-model="filters.admin_name" placeholder="制单人" clearable style="width:170px"></el-input>
            <el-button class="filter-btn" type="primary" @click="onSearch()">搜索</el-button>
        </div>

        <el-table :data="tableData" border>
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="brand_name" label="品牌"></el-table-column>
            <el-table-column prop="title" label="商品"></el-table-column>
            <el-table-column prop="market_price" label="市场价"></el-table-column>
            <el-table-column prop="price" label="售价" ></el-table-column>
            <el-table-column prop="check_status" label="审核状态" width="90">
                <template #default="scope">
                    <span>{{ OCheckStatus[scope.row.check_status]==='审核通过' ? scope.row.is_time && (new Date().getTime() < new Date(scope.row.examine_time).getTime()) ? '定时审核，待执行' : '审核通过' : OCheckStatus[scope.row.check_status] }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="examine_time" label="审核时间" width="160"></el-table-column>
            <el-table-column prop="status" label="商品状态">
                <template #default="scope">
                    <span v-if="scope.row.check_status !== OCheckStatus['待审核']">{{ Status[scope.row.status] }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="preparation_time" label="制单时间" width="160"></el-table-column>
            <el-table-column label="操作">
                <template #default="scope">
                    <div class="action-list">
                        <el-button type="primary"  @click="toEdit(scope.row, 'check')" size="small">查看</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            @current-change="onPageChange"
            :currentPage="filters.page"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import {useRouter} from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive, onActivated } from 'vue'
import { useStore } from '@/store/index'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'
import { Status } from './enum'
import { OCheckStatus } from '@/enums/product'
export default defineComponent({
name: 'ProductList',
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()

    const state = reactive({
        filters: {
            brand_name:             '',     // 品牌名称
            second_brand_name:      '',     // 二级品牌名称
            title:                  '',     // 商品名称
            check_status:           null,   // 审核状态
            admin_name:             '',     // 制单人
            examine_start_time:     '',     // 审核开始日期
            examine_end_time:       '',     // 审核结束日期
            preparation_start_time: '',     // 制单开始日期
            preparation_end_time:   '',     // 制单结束日期
            page:                   1,      // 当前页码
            size:                   10,     // 每页显示条数
        },
        total:                      0,      // 表格总条数
        tableData:                  [],     // 表格数据

        // 获取表格数据
        getList: () => {
            proxy.$http.get(`/admin/shop_product/getProductCheckList?${joinParams(state.filters)}`).then(res => {
                if(res.code == 200){
                    state.tableData = res.data || []
                    state.total = res.count
                }else{
                    state.tableData = []
                }
            })
        },
        // 跳转至编辑页
        toEdit: (row, t) => {
            router.push(`/merchant-admin/product-edit-old?id=${row.id}&t=${t}&check_type=1`)
        },
        // 搜索
        onSearch: () => {
            state.filters.page = 1
            state.getList()
        },
        // 换页
        onPageChange: (val) => {
            state.filters.page = val
            state.getList()
        }
    })

    state.getList()
    onActivated(() => {
        state.getList()
    })
    return { ...toRefs(state),  Keys, store, OCheckStatus, Status }
}
})
</script>

<style lang="stylus" scoped>
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .el-tag {
        margin-bottom:5px;
    }
    
</style>